import React from 'react';
import { Button } from 'primereact/button';

const KanbanComponent = ({job, t, onView, draggable = false, onDragStart, onDragEnd, style = {}, renderStatusBadge, formatDateValue}) => {
  const hasSchedule = job?.technology?.schedule === true;
  const title =
    job?.production_item?.name ||
    job?.technology?.name ||
    'Ismeretlen feladat';

  const hasQuantity =
    job?.quantity !== null &&
    job?.quantity !== undefined &&
    job?.unit?.name;
  const note = job?.note;
  const hasResources = Boolean(
    job?.employee?.name ||
    job?.machine?.name ||
    job?.subcontractor?.name
  );
  const hasStandardTime =
    job?.standard_time !== null &&
    job?.standard_time !== undefined &&
    job?.standard_time !== 0;
  const hasFooter = Boolean(
    hasQuantity ||
    hasStandardTime ||
    job?.deadline ||
    job?.production_item?.external_reference
  );

  const formatDate = (value) => {
    if (!value) return '-';

    if (formatDateValue) {
      return formatDateValue(value);
    }

    return value;
  };

  return (
    <div
      className="production-kanban-card production-kanban-task-card"
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      style={style}
    >
      <div className="production-kanban-task-card-header">
        <div className="production-kanban-task-card-title-block">
          <div className="production-kanban-task-card-title">{title}</div>

          {job?.project_number && (
            <div className="production-kanban-task-card-subtitle">
              {job.project_number}
            </div>
          )}

          {note && (
            <div
              className="production-kanban-task-card-note"
              title={note}
            >
              {note}
            </div>
          )}
        </div>

        <div className="production-kanban-task-card-actions">
          {renderStatusBadge && (
            <div className="production-kanban-task-card-status">
              {renderStatusBadge(job?.status, job)}
            </div>
          )}

          {onView && (
            <Button
              icon="pi pi-eye"
              tooltip={t ? t('view') : 'Megtekintés'}
              tooltipOptions={{ position: 'left' }}
              className="p-button-sm production-kanban-task-card-view-button"
              onClick={() => onView(job)}
            />
          )}
        </div>
      </div>

      {hasResources && (
        <div className="production-kanban-task-card-resources">
          {job?.employee?.name && (
            <div className="production-kanban-task-card-resource">
              <i className="pi pi-user" />
              <span>{job.employee.name}</span>
            </div>
          )}

          {job?.machine?.name && (
            <div className="production-kanban-task-card-resource">
              <i className="pi pi-cog" />
              <span>{job.machine.name}</span>
            </div>
          )}

          {job?.subcontractor?.name && (
            <div className="production-kanban-task-card-resource">
              <i className="pi pi-briefcase" />
              <span>{job.subcontractor.name}</span>
            </div>
          )}
        </div>
      )}

      {hasSchedule && (
        <div className="production-kanban-task-card-dates">
          <div className="production-kanban-task-card-date-row planned">
            <i className="pi pi-calendar" />
            <span className="production-kanban-task-card-date-type">
              Terv
            </span>
            <span className="production-kanban-task-card-date-value">
              {formatDate(job?.scheduled_from)} - {formatDate(job?.scheduled_until)}
            </span>
          </div>

          <div className="production-kanban-task-card-date-row actual">
            <i className="pi pi-check-circle" />
            <span className="production-kanban-task-card-date-type">
              Tény
            </span>
            <span className="production-kanban-task-card-date-value">
              {formatDate(job?.produced_from)} - {formatDate(job?.produced_until)}
            </span>
          </div>
        </div>
      )}

      {hasFooter && (
        <div className="production-kanban-task-card-footer">
          {hasQuantity && (
            <div className="production-kanban-task-card-meta-item">
              <span className="production-kanban-task-card-meta-label">
                {t ? t('quantity') : 'Mennyiség'}
              </span>
              <strong>{job.quantity} {job.unit.name}</strong>
            </div>
          )}

          {hasStandardTime && (
            <div className="production-kanban-task-card-meta-item">
              <span className="production-kanban-task-card-meta-label">
                {t ? t('standardTime') : 'Normaidő'}
              </span>
              <strong>{job.standard_time}</strong>
            </div>
          )}

          {job?.deadline && (
            <div className="production-kanban-task-card-meta-item">
              <span className="production-kanban-task-card-meta-label">
                {t ? t('deadline') : 'Határidő'}
              </span>
              <strong>{formatDate(job.deadline)}</strong>
            </div>
          )}

          {job?.production_item?.external_reference && (
            <div className="production-kanban-task-card-reference">
              #{job.production_item.external_reference}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default KanbanComponent;
